import { render, staticRenderFns } from "./ListWijken.vue?vue&type=template&id=2e7d4779&"
import script from "./ListWijken.vue?vue&type=script&lang=js&"
export * from "./ListWijken.vue?vue&type=script&lang=js&"
import style0 from "./ListWijken.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ListWijken.vue"
export default component.exports